/**
 * AccountProfileDropdown.jsx
 * Created by michaelbray on 2/14/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import DropdownMenuItems from './DropdownMenuItems';

import * as SecurityHelper from '../../../helpers/securityHelper';
import * as Icons from '../../sharedComponents/icons/Icons';

// TODO: Hassan and Amir - pass the necessary account info granularly or turn the account propType into a shape
const propTypes = {
    account: PropTypes.object,
    signOut: PropTypes.func
};

const defaultProps = {

};

export default class AccountProfileDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            profilePictureURL: '',
            showDropdown: false
        };

        this.toggleDropdown = this.toggleDropdown.bind(this);

        this.keyboardBindings = [];
    }

    componentDidMount() {
        if (this.props.account.account.profile_picture_id) {
            this.getProfilePicture(this.props.account.account.profile_picture_id)
            .then((response) => {
                this.setState({
                    profilePictureURL: response.data.url
                });
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.account.account.profile_picture_id !== this.props.account.account.profile_picture_id) {
            if (nextProps.account.account.profile_picture_id) {
                this.getProfilePicture(nextProps.account.account.profile_picture_id)
                .then((response) => {
                    this.setState({
                        profilePictureURL: response.data.url
                    });
                });
            }
            else {
                this.setState({
                    profilePictureURL: ''
                });
            }
        }
    }

    getProfilePicture(id) {
        const url = `${process.env.API}/media/external/${id}`;
        return axios.get(url, { headers: { Authorization: SecurityHelper.getAuthHeader() } });
    }

    toggleDropdown() {
        this.setState({
            showDropdown: !this.state.showDropdown
        });
    }

    render() {
        const firstName = this.props.account.account.first_name;
        const lastInitial = this.props.account.account.last_name[0];
        let fullName = firstName;
        if (lastInitial.length > 0) {
            fullName = `${firstName} ${lastInitial}.`;
        }
        // Set border and icon based on state's open/closed value
        let showDropdown = 'hide';
        let selectBorder = '';

        if (this.state.showDropdown) {
            showDropdown = '';
            selectBorder = 'open';
        }

        let commercialAccountIcon = "";
        if (this.props.account.account.is_commercial_account) {
            commercialAccountIcon = 'commerical-account-active';
        }

        let accountImage = (
            <div className={`rec-account-default-icon ${commercialAccountIcon}`}>
                <Icons.IconAccountCircle />
            </div>
        );
        if (this.state.profilePictureURL) {
            accountImage = <img src={this.state.profilePictureURL} alt={fullName} />;
        }

        return (
            <div className="rec-select-holder nav-profile-dropdown">
                <button
                    className={`rec-select ${selectBorder}`}
                    title="My Account"
                    aria-label="My Account"
                    onClick={this.toggleDropdown}>
                    <span className="rec-select-profile-photo">
                        {accountImage}
                    </span>
                    <span className="rec-select-label">
                        {fullName}
                    </span>
                    <span className="rec-select-icon">
                        <Icons.IconArrowDown />
                    </span>
                </button>
                <div className={`rec-select-options ${showDropdown}`}>
                    <DropdownMenuItems
                        commercialAccount={this.props.account.account.is_commercial_account}
                        signOut={this.props.signOut} />
                </div>
            </div>
        );
    }
}

AccountProfileDropdown.propTypes = propTypes;
AccountProfileDropdown.defaultProps = defaultProps;
